import Vue from 'vue'

export default {
  state: {
    // actions is an ordered list of actions
    steps_info: {},
    active_step: {},
  },
  mutations: {
    ADD_STEPS_INFO (state, { step }) {
      Vue.set(state.steps_info, step.step, step)
    },
    EMPTY_STEPS_INFO (state) {
      state.steps_info = {}
    },
    UPDATE_STEP_FINISHED (state, { step, finished }) {
      state.steps_info[step].finished = finished
    },
    SET_ACTIVE_STEP (state, { step }) {
      Vue.set(state.active_step, 0, state.steps_info[step])
    },
  },
  actions: {
    set_active_step ({ commit, state }, { step }) {
      return commit('SET_ACTIVE_STEP', { step: step })
    },
    add_steps_info ({ commit, state }, stepsInfo) {
      commit('EMPTY_STEPS_INFO')

      return Object.values(stepsInfo).forEach(step => {
        return commit('ADD_STEPS_INFO', { step: step })
      })
    },
    update_step_finished ({ commit, state }, { step, finished }) {
      return commit('UPDATE_STEP_FINISHED', { step: step, finished: finished })
    },
  },
  getters: {},
}
